import { HIDE_ERROR_FLAG } from '../../appConstants';

export {}

export const getValue = (value: any, defaultValue: any) => {
  if (!value && defaultValue) {
      return defaultValue
  }
  return value
};

export const getMaxLength = (maxLength: any) => {
  if (maxLength) {
      return maxLength.toString()
  }
  return maxLength
};

/*
export const getRequiredLabel = (isRequired: boolean, label: string, t: any) => {
  if (isRequired) {
      return `${t(label)}`
  }
  return `${t(label)} (${t('optional')})`;
};
*/

export const getRequiredLabel = (isRequired: boolean, label: string) => {
  if ((isRequired) && (label !== undefined)) {
      return label + ' *';
  } else {
      return label;
  }
};

export const handleError = (rawErrors: any) => {
  let state: any;
  let stateEmphasis: string = "";
  let stateLabel: string = "";
  if (rawErrors && rawErrors !== undefined && rawErrors[0] !== HIDE_ERROR_FLAG)  {
      state = "error";
      stateEmphasis = "";
      stateLabel=rawErrors[0];
  }
  return {state, stateEmphasis, stateLabel};
}
